// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"db766115","453":"5533d5f1","667":"b363497b","977":"81faa29e"}[chunkId] + ".chunk.js";
};